var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82422 11.4641C2.82422 11.6706 3.01208 11.849 3.21868 11.8479C3.28827 11.8476 3.34524 11.8476 3.36676 11.8476C7.21166 11.8476 10.0014 14.6652 10.0014 18.5104C10.0014 18.4226 10.0014 18.4481 10.0008 18.5191C9.99927 18.7365 10.2009 18.9473 10.4184 18.9473H19.0285C22.0042 18.9473 23.9991 16.8519 23.9991 13.7423V8.83827C23.9991 8.65361 23.8494 8.50391 23.6647 8.50391H3.15856C2.9739 8.50391 2.82422 8.6536 2.82422 8.83827V11.4641Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80042 1.20117H19.0242C21.9998 1.20117 23.9992 3.29319 23.9992 6.40615V6.49531C23.9992 6.67997 23.8494 6.82968 23.6649 6.82968H3.1609C2.97625 6.82968 2.82656 6.67997 2.82656 6.49531V6.40615C2.82656 3.29319 4.8259 1.20117 7.80042 1.20117ZM4.66403 17.1301H6.82052C7.28191 17.1301 7.65637 17.5046 7.65637 17.9661C7.65637 18.4275 7.28191 18.802 6.82052 18.802H4.66403V20.9564C4.66403 21.4189 4.28957 21.7923 3.82818 21.7923C3.59749 21.7923 3.38908 21.6987 3.23752 21.5482C3.08595 21.3967 2.99234 21.1882 2.99234 20.9564V18.802H0.835848C0.605154 18.802 0.395635 18.7083 0.245182 18.5568C0.093615 18.4052 0 18.1968 0 17.9661C0 17.5035 0.37446 17.1301 0.835848 17.1301H2.99234V14.9746C2.99234 14.5132 3.3668 14.1387 3.82818 14.1387C4.28957 14.1387 4.66403 14.5132 4.66403 14.9746V17.1301Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCreditCard);
export default __webpack_public_path__ + "static/media/add_credit_card.6b6c6f03e594c51b4f3355b4cd126efb.svg";
export { ForwardRef as ReactComponent };